<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  <nsp-checkbox-input
    id="awaitingOrders"
    name="awaitingOrders"
    label="Awaiting Orders"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('awaitingOrders')"
    [readonly]="isFieldReadOnly('awaitingOrders')"
    [value]="operationalStore.nextPort?.()?.awaitingOrders?.value"
    [ngModel]="operationalStore.nextPort?.()?.awaitingOrders?.value"
  />
  <nsp-text-input
    id="nextPort"
    name="nextPort"
    label="Next Port"
    [labelWidthPercentage]="33"
    [required]="!operationalStore.nextPort?.()?.awaitingOrders?.value"
    [readonly]="!!operationalStore.nextPort?.()?.awaitingOrders?.value"
    [value]="operationalStore.nextPort?.()?.nextPort?.value"
    [ngModel]="operationalStore.nextPort?.()?.nextPort?.value"
  />
  <nsp-number-input
    id="remainingDistance"
    name="remainingDistance"
    label="Remaining Distance"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('remainingDistance')"
    [readonly]="!!operationalStore.nextPort?.()?.awaitingOrders?.value"
    [value]="operationalStore.nextPort?.()?.remainingDistance?.value"
    [ngModel]="operationalStore.nextPort?.()?.remainingDistance?.value"
  />
  <nsp-number-input
    id="remainingTime"
    name="remainingTime"
    label="Remaining Time"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('remainingTime')"
    [readonly]="!!operationalStore.nextPort?.()?.awaitingOrders?.value"
    [value]="operationalStore.nextPort?.()?.remainingTime?.value"
    [ngModel]="operationalStore.nextPort?.()?.remainingTime?.value"
  />
  <nsp-select-input
    id="nextTimezone"
    name="nextTimezone"
    label="Next Timezone"
    [options]="timezoneOptions"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('nextTimezone')"
    [readonly]="isFieldReadOnly('nextTimezone')"
    [value]="operationalStore.nextPort?.()?.nextTimezone?.value"
    [ngModel]="operationalStore.nextPort?.()?.nextTimezone?.value"
  />
  <nsp-calendar-input
    id="etaPilotStation"
    name="etaPilotStation"
    label="ETA Pilot Station"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('etaPilotStation')"
    [readonly]="isFieldReadOnly('etaPilotStation')"
    [value]="operationalStore.nextPort?.()?.etaPilotStation?.value"
    [ngModel]="operationalStore.nextPort?.()?.etaPilotStation?.value"
  />
</form>
